<template>
  <div>
    <img
      :width="width"
      :height="height"
      :style="{ opacity: opacity }"
      :src="logoPix"
    />
  </div>
</template>

<script>
import logoPix from '@/assets/images/logo-pix-payment.svg'

export default {
  name: 'PixIcon',

  props: {
    width: {
      type: [String, Number],
      default: 10,
    },
    height: {
      type: [String, Number],
      default: 10,
    },
    opacity: {
      type: [String, Number],
      default: 10,
    },
  },

  data() {
    return {
      logoPix,
    }
  },
}
</script>
